"use client";

import React from "react";
import { Box, Card, CardContent, Typography, Grid, LinearProgress, Divider, List, ListItem, ListItemText } from "@mui/material";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import SectionTitle from "../section-title";
export default function PropertyDashboardGlanceView() {
    // Dummy data for properties
    const properties = [
        { name: "Chakra Heights", units: 50, budget: "$1,400,000", completion: 60 },
        { name: "Greenfield Apartments", units: 20, budget: "$300,000", completion: 10 },
        { name: "Fix Platform Maintenance", units: "N/A", budget: "Not set", completion: 100 },
        { name: "Launch Skyline Tower", units: 100, budget: "$3,200,000", completion: 100 },
        { name: "Add New Amenities", units: 15, budget: "$40,000", completion: 25 },
        // { name: "Redesign Lobby & Facade", units: 10, budget: "$760,000", completion: 40 },
    ];

    // Dummy data for transactions
    const transactions = [
        { desc: "New rental agreements signed", amount: "$24,000", date: "22 Dec 2:00 PM" },
        { desc: "New property listed: #421423", amount: "-", date: "21 Dec 11:21 PM" },
        { desc: "Maintenance payments for April", amount: "-", date: "21 Dec 7:35 PM" },
        { desc: "Property added for sale: #321045", amount: "-", date: "20 Dec 5:32 PM" },
        { desc: "Unlock amenities for tenants", amount: "-", date: "19 Dec 1:35 PM" },
        { desc: "New rental agreement: #9851258", amount: "-", date: "18 Dec 4:41 PM" },
    ];

    return (
        <Box >
            <Grid container spacing={3}>
                {/* Properties Card */}
                <Grid size={{ xs: 12, sm: 12, md: 8 }} >
                    <Card sx={{ minHeight: "450px", display: "flex", flexDirection: "column", borderRadius: 4 }} >
                        <CardContent>
                            <SectionTitle title="Properties Overview" />

                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Property Name</TableCell>
                                            <TableCell>Units</TableCell>
                                            <TableCell>Budget</TableCell>
                                            <TableCell>Completion</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {properties.map((property, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{property.name}</TableCell>
                                                <TableCell>{property.units} units</TableCell>
                                                <TableCell>{property.budget}</TableCell>
                                                <TableCell>
                                                    <LinearProgress
                                                        variant="determinate"
                                                        value={property.completion}
                                                        sx={{
                                                            height: 10,
                                                            borderRadius: 5,
                                                            bgcolor: "rgba(0,0,0,0.1)",
                                                            "& .MuiLinearProgress-bar": {
                                                                bgcolor: "#10a8b3ff",
                                                            },
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Transactions Card */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                    <Card sx={{ minHeight: "450px", display: "flex", flexDirection: "column", borderRadius: 4 }}>
                        <CardContent>
                            <SectionTitle title="Transactions Overview" />
                              
                            <List dense>
                                {transactions.map((tx, index) => (
                                    <ListItem key={index} sx={{ py: 0.5 }}>
                                        <ListItemText
                                            primary={tx.desc}
                                            secondary={`${tx.amount} • ${tx.date}`}
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            secondaryTypographyProps={{ fontSize: 12, color: "rgba(41, 157, 192, 0.7)" }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}
